/**
 * selectedInfo.js
 * Written by: Alex Kasemir
 */

/**
 * Description of the selected reducer
 */
const selectedInfo = (state = `quizzes`, action) => {
  switch (action.type) {
    case `SELECT_PROFILE_INFO`:
      return action.id;
    case `LOGOUT_SUCCESS`:
      return `quizzes`;
    default:
      return state;
  }
};

export default selectedInfo;
